import { render, staticRenderFns } from "./cultivate.vue?vue&type=template&id=bb63cc60"
import script from "./cultivate.vue?vue&type=script&lang=js"
export * from "./cultivate.vue?vue&type=script&lang=js"
import style0 from "./cultivate.vue?vue&type=style&index=0&id=bb63cc60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports